'use strict';

class FormularioBeneficiarioController {
  constructor($log, $scope, DataService, Message, Util, Loading, Modal, Storage) {
    'ngInject';
    this.$log = $log;
    this.$scope = $scope;
    this.DataService = DataService;
    this.Message = Message;
    this.Util = Util;
    this.Loading = Loading;
    this.Modal = Modal;
    this.Storage = Storage;
    this.listaProductos = [];
    this.dataProducto = {};
    this.conf = {};
    this.insertaNuevo = false;
    this.noExisteBeneficiario = false;
  }
  $onInit() {
    this.certificacion = this.data.certificacion;
    this.unidad_productiva = this.data.unidad_productiva;
    this.$log.log('=======================');
    this.$log.log(this.conf);
    this.tipoBeneficiario = false;
    var usuarioAux = this.Storage.getUser();
    this.mostrarCorrecciones = usuarioAux && usuarioAux.id_usuario === 4763 ? true : false;
    this.cargarParametros();
  }

  verificarBeneficiario (event) {
    this.$log.log('=======================', event);
    this.$log.log('verificarBeneficiario');
    this.Modal.confirm('Se verificará la existencia del Beneficiario en el SIGEP. ¿Desea continuar?', () => {
      var url = `certificaciones/${this.certificacion.id_certificacion}/beneficiario`;
      if (this.tipoBeneficiario) url = `${url}?tipo_beneficiario=${this.tipoBeneficiario}`;
      this.DataService.get(url)
      .then(respuesta => {
        if (respuesta) {
          this.unidad_productiva.beneficiario = respuesta.beneficiario;
          this.unidad_productiva.proceso = { beneficiario: { beneficiario: respuesta } };
          this.unidad_productiva.cuenta_validada = null;
          this.unidad_productiva.cuenta_estado = null;
          this.estadoDescripcion = null;
          this.$log.log('=======================');
          this.$log.log(respuesta);
          this.Storage.set('unidad_productiva', this.unidad_productiva);
        } else {
          this.noExisteBeneficiario = true;
        }
      });
    });
  }

  crearBeneficiario () {
    this.$log.log('=======================');
    this.$log.log('verificarBeneficiario');
    this.Modal.confirm('Se procederá a crear el Beneficiario en el SIGEP. ¿Desea continuar?', () => {
      var datosEnviar = {};
      if (this.tipoBeneficiario) datosEnviar = {tipoBeneficiario: this.tipoBeneficiario};
      this.DataService.post(`certificaciones/${this.certificacion.id_certificacion}/beneficiario`, datosEnviar)
        .then(respuesta => {
          if (respuesta) {
            this.$log.log('=======================');
            this.$log.log(respuesta);
            this.unidad_productiva.beneficiario = respuesta.beneficiario;
            this.unidad_productiva.proceso = { beneficiario: { beneficiario: respuesta } };
            this.unidad_productiva.cuenta_validada = null;
            this.unidad_productiva.cuenta_estado = null;
            this.estadoDescripcion = null;
            this.Storage.set('unidad_productiva', this.unidad_productiva);
          }
        });
    });
  }

  asociarCuenta () {
    if (!this.unidad_productiva.beneficiario) {
      this.Message.error('Primero debe buscar o crear el Beneficiario.');
      return;
    }
    this.$log.log('=======================');
    this.$log.log('asociarCuenta');
    this.Modal.confirm('Se procederá a asociar el Beneficiario SIGEP con la cuenta Bancaria. ¿Desea continuar?', () => {
      this.DataService.post(`certificaciones/${this.certificacion.id_certificacion}/cuentaBancaria`)
      .then(respuesta => {
        if (respuesta) {
          this.$log.log('=======================');
          this.$log.log(respuesta);
          this.unidad_productiva.cuenta_validada = respuesta.estadoCuenta;
          this.unidad_productiva.cuenta_estado = respuesta.estado;
          this.estadoDescripcion = this.estados.filter(item => item.sigla === this.unidad_productiva.cuenta_validada);
          if (this.estadoDescripcion && this.estadoDescripcion[0]) this.estadoDescripcion = this.estadoDescripcion[0].nombre;
          else this.estadoDescripcion = null;
          this.Storage.set('unidad_productiva', this.unidad_productiva);
        }
      });
    });
  }

  cargarParametros() {
    var url = `parametros/?grupo=CUENTA_MONEDA`;
    this.DataService.get(url)
    .then((response) => {
      if (response) {
        this.monedaDescripcion = response.filter(item => item.sigla === this.unidad_productiva.cuenta_moneda);
        if (this.monedaDescripcion && this.monedaDescripcion[0]) this.monedaDescripcion = this.monedaDescripcion[0].nombre;
      }
    });
    var urlDep = `parametros/?grupo=TIPO_CUENTA`;
    this.DataService.get(urlDep)
    .then((response1) => {
      if (response1) {
        this.tipoDescripcion = response1.filter(item => item.sigla === this.unidad_productiva.cuenta_tipo);
        if (this.tipoDescripcion && this.tipoDescripcion[0]) this.tipoDescripcion = this.tipoDescripcion[0].nombre;
      }
    });
    var urlTipo = `parametros/?grupo=DEPARTAMENTO_MEF`;
    this.DataService.get(urlTipo)
    .then((response2) => {
      if (response2) {
        this.departamentoDescripcion = response2.filter(item => item.sigla === this.unidad_productiva.cuenta_departamento);
        if (this.departamentoDescripcion && this.departamentoDescripcion[0]) this.departamentoDescripcion = this.departamentoDescripcion[0].nombre;
      }
    });
    var urlEstado = `parametros/?grupo=CUENTA_ESTADO`;
    this.DataService.get(urlEstado)
    .then((response3) => {
      if (response3) {
        this.estados = response3;
        this.estadoDescripcion = response3.filter(item => item.sigla === this.unidad_productiva.cuenta_validada);
        if (this.estadoDescripcion && this.estadoDescripcion[0]) this.estadoDescripcion = this.estadoDescripcion[0].nombre;
        else this.estadoDescripcion = null;
      }
    });
  }
}

export default FormularioBeneficiarioController;



// WEBPACK FOOTER //
// ./src/app/common/core/util/forms/formularioBeneficiario/formularioBeneficiario.controller.js